import React from "react";
import siteLogo from "../../../assets/images/logo.png";
import Input from "../../../components/form/Input";
import Button from "../../../components/form/Button";
import useForm from "../../../hooks/useForm";
import { formValidate } from "../../../helpers/formValidate";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { login } from "../../../redux/slice/authSlice";
import { useDispatch } from "react-redux";

const validation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  password: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message:
        "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
};
const AdminLogin = () => {
  const { loginPending } = useSelector((state) => state?.authProvider);
  const dispatch = useDispatch();
  const location = useLocation();

  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({ validationRules: validation });

  const navigate = useNavigate();
  const settings = useSelector((state) => state?.settings?.data);

  const handleClick = () => {
    navigate("/admin/forgot-password", {
      state: "admin",
    });
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-tr from-indigo-200 via-purple-200 to-pink-200 flex items-center justify-center px-4 py-6">
      <div className="w-full max-w-md bg-white/40 backdrop-blur-lg rounded-3xl shadow-xl p-8 border border-red-700">
        <div className="text-center mb-6">
          <img
            src={settings?.favicon?.url || siteLogo}
            alt="Memory Doodle"
            className="mx-auto h-12 w-auto"
          />
          <h1 className="text-2xl font-extrabold text-gray-800 mt-2">
            Admin Login
          </h1>
          <p className="text-sm text-gray-600">Authorized Personnel Only</p>
        </div>

        <form
          onSubmit={(event) =>
            handleSubmit(event, (val) =>
              dispatch(
                login({
                  ...val,
                  type: "admin",
                  redirect: "/admin",
                  location,
                  navigate,
                })
              )
            )
          }
          className="space-y-5"
        >
          <Input
            label={"Email"}
            inputPlaceholder={"Enter your email"}
            labelClasses={"!text-xs font-semibold text-gray-700"}
            inputType={"text"}
            value={values.email}
            inputName={"email"}
            onChange={handleChange}
            {...formValidate(errors, "email")}
          />
          <Input
            label={"Password"}
            inputPlaceholder={"Enter your password"}
            labelClasses={"!text-xs font-semibold text-gray-700"}
            inputType={"password"}
            value={values.password}
            inputName={"password"}
            onChange={handleChange}
            {...formValidate(errors, "password")}
          />

          <Button
            loading={loginPending}
            buttonHasLink={false}
            buttonType={"submit"}
            buttonLabel={"Log in"}
            buttonIconPosition={"left"}
            buttonIcon={"fa-light fa-right-to-bracket"}
            buttonClasses={
              "w-full text-white bg-gradient-to-r from-pink-500 to-red-400 hover:from-red-500 hover:to-pink-600 transition-all duration-300 ease-in-out py-2 rounded-xl shadow-lg"
            }
          />

          {/* <div className="text-right">
            <Button
              // buttonClasses={"text-sm text-gray-500 hover:text-pink-500"}
              buttonClasses={
                "text-white bg-gradient-to-r from-[#bca4d0] to-[#bca4d0] hover:to-[#fb9d43] transition-all duration-300 ease-in-out py-2 rounded-xl shadow-lg"
              }
              buttonHasLink={false}
              buttonType={"button"}
              buttonLabel={"Forgot Password?"}
              buttonFunction={handleClick}
            />
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
